export default {
  forgot_password: {
    title: 'Réinitialiser le mot de passe',
    required: '@:validation.required',
    incorrect_email_address: '@:validation.email_format',
    double_check_text: '@:login.double_check_text',
    forgot_password: 'Mot de passe oublié',
    password_reset_text: 'Saisissez votre adresse e-mail. Vous recevrez un courriel de confirmation pour réinitialiser votre mot de passe.',
    submit: 'Envoyer',
    mail_address: "Entrer l'adresse e-mail",
    input_label: '@:settings.user.email',
  },
}
